import client from "../client/client";

class ProjectInfoService {
  getActiveFeatures({ projectId }, cancelToken) {
    return client.get(`/project-information/projects/${projectId}/features`, { config: { cancelToken } });
  }
}
export default new ProjectInfoService();
